// // ========== src/components/Dashboards/AdminDashboard.jsx ==========

// import { useState } from 'react';

// const AdminDashboard = () => {
//   const [stats] = useState({
//     total_users: 1248,
//     total_students: 987,
//     total_parents: 234,
//     total_admins: 27,
//     active_today: 456,
//     total_games_played: 15620,
//     total_ai_requests: 8943,
//     revenue_today: 459.99,
//     revenue_month: 12847.50
//   });

//   const [recentUsers] = useState([
//     { id: 1, name: 'Jonas Jonaitis', email: 'jonas@example.com', role: 'student', joined: '2025-01-05' },
//     { id: 2, name: 'Ona Onaitė', email: 'ona@example.com', role: 'parent', joined: '2025-01-05' }
//   ]);

//   const [subscriptions] = useState([
//     { tier: 'FREE', count: 900, percentage: 72 },
//     { tier: 'BASIC', count: 200, percentage: 16 },
//     { tier: 'PREMIUM', count: 120, percentage: 10 },
//     { tier: 'ENTERPRISE', count: 28, percentage: 2 }
//   ]);

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-purple-50 p-8">
//       <div className="max-w-7xl mx-auto">
//         {/* Header */}
//         <div className="bg-white rounded-2xl shadow-xl p-6 mb-8">
//           <h1 className="text-4xl font-bold text-gray-800 mb-2">⚡ Admin Dashboard</h1>
//           <p className="text-gray-600">Sistema ir statistika</p>
//         </div>

//         {/* Quick Stats */}
//         <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
//           <div className="bg-gradient-to-r from-blue-500 to-purple-500 rounded-2xl shadow-lg p-6 text-white">
//             <div className="flex justify-between items-start mb-4">
//               <div className="text-4xl">👥</div>
//               <span className="text-sm bg-white bg-opacity-20 px-2 py-1 rounded-full">+12%</span>
//             </div>
//             <p className="text-3xl font-bold">{stats.total_users}</p>
//             <p className="text-sm opacity-90">Viso vartotojų</p>
//           </div>

//           <div className="bg-gradient-to-r from-green-500 to-teal-500 rounded-2xl shadow-lg p-6 text-white">
//             <div className="flex justify-between items-start mb-4">
//               <div className="text-4xl">🎮</div>
//               <span className="text-sm bg-white bg-opacity-20 px-2 py-1 rounded-full">+8%</span>
//             </div>
//             <p className="text-3xl font-bold">{stats.total_games_played}</p>
//             <p className="text-sm opacity-90">Žaidimų sužaista</p>
//           </div>

//           <div className="bg-gradient-to-r from-orange-500 to-red-500 rounded-2xl shadow-lg p-6 text-white">
//             <div className="flex justify-between items-start mb-4">
//               <div className="text-4xl">🤖</div>
//               <span className="text-sm bg-white bg-opacity-20 px-2 py-1 rounded-full">+15%</span>
//             </div>
//             <p className="text-3xl font-bold">{stats.total_ai_requests}</p>
//             <p className="text-sm opacity-90">AI užklausų</p>
//           </div>

//           <div className="bg-gradient-to-r from-yellow-500 to-orange-500 rounded-2xl shadow-lg p-6 text-white">
//             <div className="flex justify-between items-start mb-4">
//               <div className="text-4xl">💰</div>
//               <span className="text-sm bg-white bg-opacity-20 px-2 py-1 rounded-full">+22%</span>
//             </div>
//             <p className="text-3xl font-bold">€{stats.revenue_month}</p>
//             <p className="text-sm opacity-90">Šio mėnesio pajamos</p>
//           </div>
//         </div>

//         {/* Users by Role */}
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
//           <div className="bg-white rounded-2xl shadow-lg p-6">
//             <div className="flex items-center gap-3 mb-4">
//               <div className="text-5xl">👨‍🎓</div>
//               <div>
//                 <p className="text-2xl font-bold text-gray-800">{stats.total_students}</p>
//                 <p className="text-sm text-gray-600">Mokinių</p>
//               </div>
//             </div>
//             <div className="w-full bg-gray-200 rounded-full h-3">
//               <div className="bg-blue-500 h-3 rounded-full" style={{width: '79%'}}></div>
//             </div>
//           </div>

//           <div className="bg-white rounded-2xl shadow-lg p-6">
//             <div className="flex items-center gap-3 mb-4">
//               <div className="text-5xl">👨‍👩‍👧</div>
//               <div>
//                 <p className="text-2xl font-bold text-gray-800">{stats.total_parents}</p>
//                 <p className="text-sm text-gray-600">Tėvų</p>
//               </div>
//             </div>
//             <div className="w-full bg-gray-200 rounded-full h-3">
//               <div className="bg-green-500 h-3 rounded-full" style={{width: '19%'}}></div>
//             </div>
//           </div>

//           <div className="bg-white rounded-2xl shadow-lg p-6">
//             <div className="flex items-center gap-3 mb-4">
//               <div className="text-5xl">⚡</div>
//               <div>
//                 <p className="text-2xl font-bold text-gray-800">{stats.total_admins}</p>
//                 <p className="text-sm text-gray-600">Administratorių</p>
//               </div>
//             </div>
//             <div className="w-full bg-gray-200 rounded-full h-3">
//               <div className="bg-purple-500 h-3 rounded-full" style={{width: '2%'}}></div>
//             </div>
//           </div>
//         </div>

//         {/* Subscriptions */}
//         <div className="bg-white rounded-2xl shadow-xl p-8 mb-8">
//           <h2 className="text-2xl font-bold text-gray-800 mb-6">💳 Prenumeratos</h2>
//           <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
//             {subscriptions.map((sub, index) => (
//               <div key={index} className="text-center p-6 bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl">
//                 <p className="text-sm font-bold text-gray-600 mb-2">{sub.tier}</p>
//                 <p className="text-4xl font-bold text-gray-800 mb-2">{sub.count}</p>
//                 <div className="w-full bg-gray-200 rounded-full h-2 mb-2">
//                   <div
//                     className="bg-gradient-to-r from-purple-500 to-pink-500 h-2 rounded-full"
//                     style={{width: `${sub.percentage}%`}}
//                   ></div>
//                 </div>
//                 <p className="text-xs text-gray-600">{sub.percentage}% vartotojų</p>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Recent Users */}
//         <div className="bg-white rounded-2xl shadow-xl p-8 mb-8">
//           <h2 className="text-2xl font-bold text-gray-800 mb-6">👥 Naujausi vartotojai</h2>
//           <div className="overflow-x-auto">
//             <table className="w-full">
//               <thead className="bg-gray-50">
//                 <tr>
//                   <th className="px-6 py-3 text-left text-xs font-bold text-gray-600 uppercase">Vardas</th>
//                   <th className="px-6 py-3 text-left text-xs font-bold text-gray-600 uppercase">El. paštas</th>
//                   <th className="px-6 py-3 text-left text-xs font-bold text-gray-600 uppercase">Rolė</th>
//                   <th className="px-6 py-3 text-left text-xs font-bold text-gray-600 uppercase">Prisijungė</th>
//                   <th className="px-6 py-3 text-left text-xs font-bold text-gray-600 uppercase">Veiksmai</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-200">
//                 {recentUsers.map((user) => (
//                   <tr key={user.id} className="hover:bg-gray-50">
//                     <td className="px-6 py-4 text-sm font-medium text-gray-900">{user.name}</td>
//                     <td className="px-6 py-4 text-sm text-gray-600">{user.email}</td>
//                     <td className="px-6 py-4">
//                       <span className={`px-3 py-1 text-xs font-bold rounded-full ${
//                         user.role === 'student' ? 'bg-blue-100 text-blue-700' :
//                         user.role === 'parent' ? 'bg-green-100 text-green-700' :
//                         'bg-purple-100 text-purple-700'
//                       }`}>
//                         {user.role}
//                       </span>
//                     </td>
//                     <td className="px-6 py-4 text-sm text-gray-600">{user.joined}</td>
//                     <td className="px-6 py-4">
//                       <button className="text-blue-600 hover:text-blue-800 text-sm font-bold">
//                         Peržiūrėti
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* Actions */}
//         <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
//           <button className="p-6 bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-2xl font-bold text-lg shadow-lg hover:shadow-xl transition transform hover:scale-105">
//             👥 Vartotojai
//           </button>
//           <button className="p-6 bg-gradient-to-r from-green-500 to-teal-500 text-white rounded-2xl font-bold text-lg shadow-lg hover:shadow-xl transition transform hover:scale-105">
//             🎮 Žaidimai
//           </button>
//           <button className="p-6 bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-2xl font-bold text-lg shadow-lg hover:shadow-xl transition transform hover:scale-105">
//             📊 Analitika
//           </button>
//           <button className="p-6 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-2xl font-bold text-lg shadow-lg hover:shadow-xl transition transform hover:scale-105">
//             ⚙️ Nustatymai
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminDashboard;


// ========== src/components/Dashboards/AdminDashboard.jsx ==========

import { useState, useEffect } from 'react';
import * as api from '../../utils/api';

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Real data from API
  const [recentUsers, setRecentUsers] = useState([]);
  const [subscriptions, setSubscriptions] = useState([]);

  useEffect(() => {
    loadPlatformStats();
    loadRecentUsers();
    loadSubscriptions();
  }, []);

  const loadPlatformStats = async () => {
    setLoading(true);
    setError(null);
    try {
      const statsData = await api.getPlatformStats();
      if (statsData) {
        setStats(statsData);
      } else {
        setError(statsData.detail || "Nepavyko gauti platformos statistikos.");
      }
    } catch (err) {
      console.error("Klaida gaunant platformos statistiką:", err);
      setError("Sistemos klaida gaunant platformos statistiką.");
    } finally {
      setLoading(false);
    }
  };

  const loadRecentUsers = async () => {
    try {
      const data = await api.getRecentUsers(10);
      if (data && data.users) {
        setRecentUsers(data.users);
      }
    } catch (err) {
      console.error("Klaida gaunant naujausius vartotojus:", err);
    }
  };

  const loadSubscriptions = async () => {
    try {
      const data = await api.getSubscriptionStats();
      if (data && data.subscriptions) {
        setSubscriptions(data.subscriptions);
      }
    } catch (err) {
      console.error("Klaida gaunant prenumeratų statistiką:", err);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
    window.location.href = '/';
  };

  const handleUsersClick = () => {
    alert('Vartotojų valdymo funkcija bus pridėta ateityje');
  };

  const handleGamesClick = () => {
    alert('Žaidimų valdymo funkcija bus pridėta ateityje');
  };

  const handleAnalyticsClick = () => {
    alert('Analitikos funkcija bus pridėta ateityje');
  };

  const handleSettingsClick = () => {
    alert('Nustatymų funkcija bus pridėta ateityje');
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-xl">Kraunami statistikos duomenys...</p>
      </div>
    );
  }

  if (error) {
    return <div className="min-h-screen flex items-center justify-center text-red-500 text-center p-8">{error}</div>;
  }

  if (!stats) {
    return <div className="min-h-screen flex items-center justify-center text-center p-8">Statistikos duomenų nėra.</div>;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-purple-50 p-8">
      <div className="max-w-7xl mx-auto">
        {/* Header with Logout */}
        <div className="bg-white rounded-2xl shadow-xl p-6 mb-8 flex justify-between items-center">
          <div>
            <h1 className="text-4xl font-bold text-gray-800 mb-2">⚡ Administratoriaus Skydas</h1>
            <p className="text-gray-600">Sistema ir statistika</p>
          </div>
          <button
            onClick={handleLogout}
            className="px-6 py-3 bg-red-500 text-white rounded-xl font-bold hover:bg-red-600 transition transform hover:scale-105"
          >
            Atsijungti
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          <div className="bg-gradient-to-r from-blue-500 to-purple-500 rounded-2xl shadow-lg p-6 text-white">
            <div className="flex justify-between items-start mb-4">
              <div className="text-4xl">👥</div>
            </div>
            <p className="text-3xl font-bold">{stats.total_users}</p>
            <p className="text-sm opacity-90">Viso vartotojų</p>
          </div>
          <div className="bg-gradient-to-r from-green-500 to-teal-500 rounded-2xl shadow-lg p-6 text-white">
            <div className="flex justify-between items-start mb-4">
              <div className="text-4xl">🎮</div>
            </div>
            <p className="text-3xl font-bold">{stats.total_games_played}</p>
            <p className="text-sm opacity-90">Žaidimų sužaista</p>
          </div>
          <div className="bg-gradient-to-r from-orange-500 to-red-500 rounded-2xl shadow-lg p-6 text-white">
            <div className="flex justify-between items-start mb-4">
              <div className="text-4xl">🤖</div>
            </div>
            <p className="text-3xl font-bold">{stats.total_ai_requests}</p>
            <p className="text-sm opacity-90">AI užklausų</p>
          </div>
          <div className="bg-gradient-to-r from-yellow-500 to-orange-500 rounded-2xl shadow-lg p-6 text-white">
            <div className="flex justify-between items-start mb-4">
              <div className="text-4xl">💰</div>
            </div>
            <p className="text-3xl font-bold">€{stats.revenue_month?.toFixed(2)}</p>
            <p className="text-sm opacity-90">Šio mėnesio pajamos</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <div className="bg-white rounded-2xl shadow-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="text-5xl">👨‍🎓</div>
              <div>
                <p className="text-2xl font-bold text-gray-800">{stats.total_students}</p>
                <p className="text-sm text-gray-600">Mokinių</p>
              </div>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-3">
              <div className="bg-blue-500 h-3 rounded-full" style={{ width: `${(stats.total_students / stats.total_users * 100) || 0}%` }}></div>
            </div>
          </div>
          <div className="bg-white rounded-2xl shadow-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="text-5xl">👨‍👩‍👧</div>
              <div>
                <p className="text-2xl font-bold text-gray-800">{stats.total_parents}</p>
                <p className="text-sm text-gray-600">Tėvų</p>
              </div>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-3">
              <div className="bg-green-500 h-3 rounded-full" style={{ width: `${(stats.total_parents / stats.total_users * 100) || 0}%` }}></div>
            </div>
          </div>
          <div className="bg-white rounded-2xl shadow-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="text-5xl">⚡</div>
              <div>
                <p className="text-2xl font-bold text-gray-800">{stats.total_admins}</p>
                <p className="text-sm text-gray-600">Administratorių</p>
              </div>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-3">
              <div className="bg-purple-500 h-3 rounded-full" style={{ width: `${(stats.total_admins / stats.total_users * 100) || 0}%` }}></div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">💳 Prenumeratos</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            {subscriptions.map((sub, index) => (
              <div key={index} className="text-center p-6 bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl">
                <p className="text-sm font-bold text-gray-600 mb-2">{sub.tier}</p>
                <p className="text-4xl font-bold text-gray-800 mb-2">{sub.count}</p>
                <div className="w-full bg-gray-200 rounded-full h-2 mb-2">
                  <div
                    className="bg-gradient-to-r from-purple-500 to-pink-500 h-2 rounded-full"
                    style={{ width: `${sub.percentage}%` }}
                  ></div>
                </div>
                <p className="text-xs text-gray-600">{sub.percentage}% vartotojų</p>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">👥 Naujausi vartotojai</h2>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-bold text-gray-600 uppercase">Vardas</th>
                  <th className="px-6 py-3 text-left text-xs font-bold text-gray-600 uppercase">El. paštas</th>
                  <th className="px-6 py-3 text-left text-xs font-bold text-gray-600 uppercase">Rolė</th>
                  <th className="px-6 py-3 text-left text-xs font-bold text-gray-600 uppercase">Prisijungė</th>
                  <th className="px-6 py-3 text-left text-xs font-bold text-gray-600 uppercase">Veiksmai</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {recentUsers.map((user) => (
                  <tr key={user._id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 text-sm font-medium text-gray-900">{user.name}</td>
                    <td className="px-6 py-4 text-sm text-gray-600">{user.email}</td>
                    <td className="px-6 py-4">
                      <span className={`px-3 py-1 text-xs font-bold rounded-full ${user.role === 'student' ? 'bg-blue-100 text-blue-700' :
                        user.role === 'parent' ? 'bg-green-100 text-green-700' :
                          'bg-purple-100 text-purple-700'
                        }`}>
                        {user.role}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600">{user.joined}</td>
                    <td className="px-6 py-4">
                      <button className="text-blue-600 hover:text-blue-800 text-sm font-bold">
                        Peržiūrėti
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          <button
            onClick={handleUsersClick}
            className="p-6 bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-2xl font-bold text-lg shadow-lg hover:shadow-xl transition transform hover:scale-105"
          >
            👥 Vartotojai
          </button>
          <button
            onClick={handleGamesClick}
            className="p-6 bg-gradient-to-r from-green-500 to-teal-500 text-white rounded-2xl font-bold text-lg shadow-lg hover:shadow-xl transition transform hover:scale-105"
          >
            🎮 Žaidimai
          </button>
          <button
            onClick={handleAnalyticsClick}
            className="p-6 bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-2xl font-bold text-lg shadow-lg hover:shadow-xl transition transform hover:scale-105"
          >
            📊 Analitika
          </button>
          <button
            onClick={handleSettingsClick}
            className="p-6 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-2xl font-bold text-lg shadow-lg hover:shadow-xl transition transform hover:scale-105"
          >
            ⚙️ Nustatymai
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;